<template>
  <div>
    <Info :alert="true">
      {{ $t('components.CompaniesSurveyTemplateForm.question.disabled.alertInfo') }}
    </Info>
    <Info class="info">
      {{ $t('components.CompaniesSurveyTemplateForm.question.disabled.info') }}
    </Info>
  </div>
</template>

<script>
import Info from '../Info'
export default {
  name: 'CompaniesSurveyTemplateFormDisabledQuestion',
  components: { Info },
}
</script>

<style lang="scss" scoped>
.info {
  margin-top: 32px;
}
</style>
